<p-dialog
  [header]="titleKey | abpLocalization"
  [(visible)]="dialogVisible"
  [modal]="true"
  [position]="'top'"
  [style]="{ width: '32rem' }"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  (onHide)="onHide()"
  styleClass="ivr-instance-form"
  contentStyleClass="ivr-instance-form__content">
  <form [formGroup]="form" class="ivr-instance-form__body" novalidate>
    <div class="row g-3">
      <div class="col-12">
        <div class="ivr-instance-form__field">
          <label for="ivr-name" class="ivr-instance-form__label indicates-required-field">
            {{ 'FreeswitchIntegration::InstanceName' | abpLocalization }}
          </label>
          <input
            pInputText
            id="ivr-name"
            formControlName="name"
            maxlength="100"
            class="form-control w-full" />
        </div>
      </div>

      <div class="col-12 col-md-6">
        <div class="ivr-instance-form__field">
          <label for="ivr-ip" class="ivr-instance-form__label indicates-required-field">
            {{ 'FreeswitchIntegration::IpAddress' | abpLocalization }}
          </label>
          <input
            pInputText
            id="ivr-ip"
            formControlName="ipAddress"
            placeholder="192.168.1.1"
            class="form-control w-full" />
        </div>
      </div>

      <div class="col-12 col-md-6">
        <div class="ivr-instance-form__field">
          <label for="ivr-port" class="ivr-instance-form__label indicates-required-field">
            {{ 'FreeswitchIntegration::Port' | abpLocalization }}
          </label>
          <p-inputNumber
            inputId="ivr-port"
            formControlName="port"
            [min]="1"
            [max]="65535"
            [useGrouping]="false"
            placeholder="5060"
            styleClass="w-full"
            inputStyleClass="form-control w-full">
          </p-inputNumber>
        </div>
      </div>

      <div class="col-12">
        <div class="ivr-instance-form__field">
          <label class="ivr-instance-form__label">
            {{ 'FreeswitchIntegration::AssignTenants' | abpLocalization }}
          </label>
          <p-multiselect
            [options]="tenants"
            [ngModel]="selectedTenantIds"
            (ngModelChange)="selectedTenantIds = $event ?? []"
            [ngModelOptions]="{ standalone: true }"
            optionLabel="name"
            optionValue="id"
            placeholder="{{ 'FreeswitchIntegration::SearchTenants' | abpLocalization }}"
            [filter]="true"
            [showClear]="true"
            appendTo="body"
            styleClass="w-full">
          </p-multiselect>

          <ul
            *ngIf="selectedTenants.length > 0"
            class="ivr-instance-form__tenant-list">
            <li
              *ngFor="let tenant of selectedTenants; trackBy: trackByTenantId"
              class="ivr-instance-form__tenant-item">
              <span class="ivr-instance-form__tenant-name">
                <i class="pi pi-building" aria-hidden="true"></i>
                {{ tenant.name }}
              </span>
              <button
                type="button"
                class="btn btn-link btn-sm ivr-instance-form__tenant-remove"
                (click)="removeTenant(tenant.id)">
                {{ 'FreeswitchIntegration::Delete' | abpLocalization }}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </form>

  <ng-template #footer>
    <cx-form-actions
      layout="dialog"
      [cancelLabel]="'FreeswitchIntegration::Cancel' | abpLocalization"
      [saveLabel]="submitLabelKey | abpLocalization"
      saveType="button"
      [disabled]="submitting || form.invalid"
      [isSubmitting]="submitting"
      (cancel)="cancel()"
      (save)="submit()">
    </cx-form-actions>
  </ng-template>
</p-dialog>
